/** Enterprise Excel export design tokens — v2 */

export const FONT = 'Segoe UI';

export const SIZE = {
  title: 18,
  section: 13,
  tableHead: 11,
  body: 11,
  meta: 10,
  kpiValue: 15,
  kpiLabel: 11,
};

/** Indian accounting: positive ₹#,##0.00 | negative (₹#,##0.00) */
export const INR = '"₹"#,##0.00_);("₹"#,##0.00)';
/** Compact positive-only INR — ledger credit/debit columns (saves ~2 chars width) */
export const INR_COMPACT = '"₹"#,##0.00';
export const INR_INT = '#,##0_);(#,##0)';
export const PCT = '0.0%';

export const SHEET = {
  SUMMARY: 'Executive Summary Dashboard',
  TRANSACTIONS_CLIENT: 'Client Transactions',
  TRANSACTIONS_OWNER: 'Owner Transactions',
  TRANSACTIONS_TREASURY: 'Treasury & Internal',
  TRANSACTIONS_ALL: 'All Transactions',
  GST: 'GST Analysis',
  CHANNELS: 'Payment Channel Analysis',
};

export const TABLE = {
  TRANSACTIONS: 'DE_Transactions',
  CLIENT_TXNS: 'DE_ClientTransactions',
  OWNER_TXNS: 'DE_OwnerTransactions',
  TREASURY_TXNS: 'DE_TreasuryTransactions',
  GST: 'DE_GSTAnalysis',
  CHANNELS: 'DE_PaymentChannels',
  AUDIT: 'DE_AuditChecks',
  CHANNEL_VOLUME: 'DE_ChannelVolume',
};

export const COMPANY = {
  name: 'Development Express',
  tagline: 'Heavy Equipment Rental · Since 2011',
  module: 'Development Express Finance Module',
};

export const COLOR = {
  navy: 'FF1B2A4A',
  navyDark: 'FF0F1A2E',
  navyLight: 'FF2D4A73',
  white: 'FFFFFFFF',
  muted: 'FF64748B',
  border: 'FFD0D7E2',
  zebra: 'FFF4F6F9',
  credit: 'FF047857',
  creditBg: 'FFE8F5EF',
  debit: 'FFB91C1C',
  debitBg: 'FFFEF2F2',
  gold: 'FFB8860B',
  goldBg: 'FFFFF8E7',
  success: 'FF059669',
  successBg: 'FFECFDF5',
  danger: 'FFDC2626',
  dangerBg: 'FFFEF2F2',
  warn: 'FFD97706',
  link: 'FF2563EB',
};

/** Full-width column count for portrait ERP layout */
export const PAGE_COLS = 16;

export const TABLE_THEME = {
  theme: 'TableStyleMedium2',
  showRowStripes: true,
  showFirstColumn: false,
};

/** Cleaner tables for dashboard sheets — no filter chrome */
export const TABLE_THEME_EXEC = {
  theme: 'TableStyleMedium9',
  showRowStripes: true,
  showFirstColumn: false,
};
